var map = {
	"./": 476,
	"./OldUi": 2664,
	"./OldUi.js": 2664,
	"./SpireonNew": 2665,
	"./SpireonNew.js": 2665,
	"./SpireonOld": 2666,
	"./SpireonOld.js": 2666,
	"./index": 476,
	"./index.js": 476,
	"./style": 367,
	"./style.js": 367
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4172;